// Tennis Ball product options refresh.
(() => {
  const handle = location.pathname.split('/products/')[1]?.split(/[/?#]/)[0];
  const fixedHandles = new Set([
    'red', 'the-red', 'orange', 'the-orange', 'yellow', 'the-yellow',
    'green', 'the-green', 'blue', 'the-blue', 'indigo', 'the-indigo',
    'violet', 'the-violet', 'brown', 'the-brown', 'white', 'the-white',
    'black', 'the-black', 'chestnut-mont-blanc', 'black-forest',
    'red-velvet', 'heart-mousse', 'plum-blossom', 'cupcakes-6pc', 'vegan-cupcakes-12pc', 'cake-pops'
  ]);
  const blindBox = handle === 'blind-box-cakes';
  const plumBlossom = handle === 'plum-blossom';
  const bestHusbandDad = handle === 'best-husband-dad';
  const tennisBall = handle === 'tennis-ball';
  const signatureDesign = window.cakeOrderConfig?.signatureDesign === true;
const signatureFlavorCake = plumBlossom || bestHusbandDad || tennisBall || signatureDesign;
  const mysteryStyleCake = blindBox || signatureFlavorCake;
  const cupcakes = handle === 'cupcakes-6pc' || handle === 'vegan-cupcakes-12pc';
  const cakePops = handle === 'cake-pops';
  const orderType = cupcakes ? 'cupcakes' : blindBox ? 'blind_box' : 'fixed';
  const signatureWithoutAccessories = new Set([
    'black-forest', 'chestnut-mont-blanc', 'red-velvet', 'heart-mousse', 'plum-blossom', 'best-husband-dad', 'tennis-ball'
  ]);
  const showAccessories = !signatureWithoutAccessories.has(handle) && !signatureDesign;
  const accessoryHandles = new Set([
    'utensils', 'utensils-5pc', 'birthday-hat', 'birthday-cone-hat',
    'happy-birthday-topper', 'insulated-bag-with-ice-packs', 'candle-1pc', 'candle'
  ]);

  const root = document.querySelector('product-info');
  const form = root?.querySelector('form[data-type="add-to-cart-form"]');
  if (!form) return;

  if (!accessoryHandles.has(handle)) {
    const hideQuantityControl = () => {
      root.querySelectorAll('[name="quantity"]').forEach((quantityInput) => {
        quantityInput.value = '1';
        quantityInput.readOnly = true;
      });
      root.querySelectorAll('quantity-input').forEach((quantityControl) => {
        (quantityControl.closest('.product-form__quantity') || quantityControl).style.display = 'none';
      });
    };
    hideQuantityControl();
    new MutationObserver(hideQuantityControl).observe(root, { childList: true, subtree: true });
  }

  // This property is part of the normal Shopify product form, so it works on
  // every product page, including products without custom cake options.
  let messageBox = form.querySelector('.cake-message');
  if (!form.dataset.cakeMessageReady) {
    form.dataset.cakeMessageReady = 'true';
    messageBox = document.createElement('div');
    messageBox.className = 'cake-message';
    messageBox.innerHTML = '<label for="cake-order-message">Message (optional)</label><textarea id="cake-order-message" name="properties[Message]" rows="3" placeholder="Anything you would like us to know?"></textarea><style>.cake-message{margin:1.2rem 0}.cake-message label{display:block;margin:0 0 .4rem;font-size:1.5rem}.cake-message textarea{width:100%;min-height:8rem;padding:.8rem;resize:vertical;font:inherit}</style>';
  }

  if (!mysteryStyleCake && !fixedHandles.has(handle)) {
    const messageButton = form.querySelector('button[name="add"], [type="submit"]');
    (messageButton?.parentElement || form).before(messageBox);
    return;
  }
  if (form.dataset.cakeOrderReady) return;
  form.dataset.cakeOrderReady = 'true';

  if (blindBox) {
    const description = document.createElement('div');
    description.className = 'blind-box-description';
    description.textContent = "You choose the flavors. We'll design your cake with a simple yet pretty look.";
    description.style.cssText = 'margin:1.2rem 0;padding:1rem 1.2rem;border:1px solid rgba(var(--color-foreground),.18);border-radius:.4rem;';
    const productTitle = root.querySelector('h1');
    if (productTitle) productTitle.insertAdjacentElement('afterend', description);
    else form.before(description);
  }

  const addOnVariant = {
    1: 59944377974865, 2: 59944378007633, 3: 59944378040401,
    4: 59944378073169, 5: 59944378105937, 6: 59944378138705,
    8: 59944378171473, 10: 59944378204241, 12: 59944378237009,
    15: 59944378269777, 16: 59944378302545, 18: 59944378335313,
    20: 59944378368081
  };
  const blindSize = {
    '59929721831505': 4, '59929721864273': 6,
    '59929721897041': 8, '59929721929809': 10
  };
  const basePrice = {
    4: { Vanilla: 0, Chocolate: 1, Matcha: 1, 'Earl Grey': 2, Pandan: 2 },
    6: { Vanilla: 0, Chocolate: 2, Matcha: 2, 'Earl Grey': 4, Pandan: 4 },
    8: { Vanilla: 0, Chocolate: 3, Matcha: 3, 'Earl Grey': 5, Pandan: 5 },
    10: { Vanilla: 0, Chocolate: 4, Matcha: 4, 'Earl Grey': 6, Pandan: 6 }
  };
  const creamPrice = {
    4: { 'Original / Vanilla': 0, 'Black Sesame': 3, Oreo: 3, Matcha: 6, Chocolate: 6, 'Jasmine Tea': 6, Raspberry: 6, Blueberry: 6 },
    6: { 'Original / Vanilla': 0, 'Black Sesame': 5, Oreo: 5, Matcha: 10, Chocolate: 10, 'Jasmine Tea': 10, Raspberry: 10, Blueberry: 10 },
    8: { 'Original / Vanilla': 0, 'Black Sesame': 8, Oreo: 8, Matcha: 16, Chocolate: 16, 'Jasmine Tea': 16, Raspberry: 16, Blueberry: 16 },
    10: { 'Original / Vanilla': 0, 'Black Sesame': 10, Oreo: 10, Matcha: 20, Chocolate: 20, 'Jasmine Tea': 20, Raspberry: 20, Blueberry: 20 }
  };
  const fillingPrice = {
    4: { Strawberry: 0, Blueberry: 0, 'Green Grape': 0, Raspberry: 0, Banana: 0, 'Oreo Crumbs': 0, 'Taro Paste': 0, 'Canned Peach': 0, 'Seaweed Meat Floss': 0, 'Milk Oatmeal': 0, 'Lemon Curd': 5, 'Chestnut Paste': 5, 'Coconut Rice Pudding': 5, 'Dubai Chocolate': 5, 'Milk Jelly': 5, 'Matcha Jelly': 6, 'Coconut Jelly': 6, 'Chocolate Jelly': 6 },
    6: { Strawberry: 0, Blueberry: 0, 'Green Grape': 0, Raspberry: 0, Banana: 0, 'Oreo Crumbs': 0, 'Taro Paste': 0, 'Canned Peach': 0, 'Seaweed Meat Floss': 0, 'Milk Oatmeal': 0, 'Lemon Curd': 8, 'Chestnut Paste': 8, 'Coconut Rice Pudding': 8, 'Dubai Chocolate': 8, 'Milk Jelly': 8, 'Matcha Jelly': 10, 'Coconut Jelly': 10, 'Chocolate Jelly': 10 },
    8: { Strawberry: 0, Blueberry: 0, 'Green Grape': 0, Raspberry: 0, Banana: 0, 'Oreo Crumbs': 0, 'Taro Paste': 0, 'Canned Peach': 0, 'Seaweed Meat Floss': 0, 'Milk Oatmeal': 0, 'Lemon Curd': 12, 'Chestnut Paste': 12, 'Coconut Rice Pudding': 12, 'Dubai Chocolate': 12, 'Milk Jelly': 12, 'Matcha Jelly': 15, 'Coconut Jelly': 15, 'Chocolate Jelly': 15 },
    10: { Strawberry: 0, Blueberry: 0, 'Green Grape': 0, Raspberry: 0, Banana: 0, 'Oreo Crumbs': 0, 'Taro Paste': 0, 'Canned Peach': 0, 'Seaweed Meat Floss': 0, 'Milk Oatmeal': 0, 'Lemon Curd': 15, 'Chestnut Paste': 15, 'Coconut Rice Pudding': 15, 'Dubai Chocolate': 15, 'Milk Jelly': 15, 'Matcha Jelly': 18, 'Coconut Jelly': 18, 'Chocolate Jelly': 18 }
  };
  // Only Filling 1 on 4-inch cakes uses the 6-inch filling prices.
  const fillingPricesFor = (cakeSize, filling) =>
    fillingPrice[cakeSize === 4 && filling === 'filling-1' ? 6 : cakeSize];

  const finishPrice = {
    4: { 'Heavy whipping cream': 0, 'Italian buttercream': 8, 'Italian buttercream with chocolate velvet coating': 20 },
    6: { 'Heavy whipping cream': 0, 'Italian buttercream': 10, 'Italian buttercream with chocolate velvet coating': 30 },
    8: { 'Heavy whipping cream': 0, 'Italian buttercream': 16, 'Italian buttercream with chocolate velvet coating': 40 },
    10: { 'Heavy whipping cream': 0, 'Italian buttercream': 25, 'Italian buttercream with chocolate velvet coating': 50 }
  };
  const finishAddOnVariant = {
  8: 59944378171473,
  10: 59944378204241,
  16: 59944378302545,
  20: 59944378368081,
  25: 60167338524753,
  30: 60167339245649,
  40: 60167340916817,
  50: 60167341408337
};
  const finishProductHandle = 'mystery-box-finish';
  const accessories = [
    ['Utensils (5pc)', 2, 59949429293137],
    ['Birthday hat', 1, 59949429424209],
    ['Birthday cone hat', 2, 59949429456977],
    ['Happy birthday topper', 1, 59949429817425],
    ['Candle (1pc)', 1, 59967150096465]
  ];
  const options = prices => Object.entries(prices)
    .map(([name, price]) => `<option value="${name}">${name}${price ? ` +$${price}` : ''}</option>`)
    .join('');

  const cupcakeChoices = `<div class="cake-order__custom"><h3>Cupcake selections</h3>${handle === 'vegan-cupcakes-12pc' ? '<p>Our vegan cupcakes are made with vegan butter, coconut milk, an egg substitute, and vegan buttercream frosting.</p>' : ''}<p>Choose one flavor per dozen of cupcakes. Random yet pretty design based on selected flavor.</p><p><strong>Flavor details</strong><br>Strawberry: Vanilla sponge cake + strawberry cream + fresh strawberries.<br>Blueberry: Chocolate sponge cake + blueberry cream + fresh blueberries.<br>Raspberry: Vanilla sponge cake + raspberry cream + fresh raspberries.<br>Mango (seasonal): Pandan sponge cake + coconut cream + fresh mango or canned yellow peach.<br>Chocolate: Chocolate sponge cake + chocolate cream + chocolate chips.<br>Matcha: Matcha sponge cake + matcha cream + fresh green grapes.<br>Oreo: Chocolate sponge cake + Oreo cream + Oreo crumbs.</p><label>Flavor<select required name="properties[Cupcake flavor]"><option value="">Select a flavor</option>${['Strawberry', 'Raspberry', 'Blueberry', 'Mango (seasonal)', 'Chocolate', 'Matcha', 'Oreo'].map(name => `<option value="${name}">${name}</option>`).join('')}</select></label></div>`;
  const cakePopChoices = `<div class="cake-order__custom"><h3>Cake Pop selections</h3><p>We use premium Belgian Chocolate for cake pops coating. Minimum 20 pcs per order. Random designs. Choose one color and cake base per 20 pcs. Contact us for customized quantity and/or design.</p><label>Cake base<select required name="properties[Cake pop base]"><option value="">Select a cake base</option>${['Vanilla', 'Chocolate', 'Matcha', 'Pandan', 'Earl Grey'].map(name => `<option value="${name}">${name}</option>`).join('')}</select></label><label>Color<input required type="text" name="properties[Cake pop color]" placeholder="Example: pastel pink"></label></div>`;
  const mysteryChoices = `<div class="cake-order__blind"><h3>Mystery Box Selections</h3><p>Prices change by selected flavors and accessories.</p><label>Cake base<select data-cake-select="base" name="properties[Cake base]"></select></label><label>Cream flavor<select data-cake-select="cream" name="properties[Cream flavor]"></select></label><label>Filling 1<select data-cake-select="filling-1" name="properties[Filling 1]"></select></label><label>Filling 2<select data-cake-select="filling-2" name="properties[Filling 2]"></select></label><label>Finish<select data-cake-select="finish" name="properties[Finish]"></select></label></div>`;
  const plumChoices = `<div class="cake-order__blind"><h3>Signature Cake Flavor Selections</h3><p>Prices change by selected flavors. Complementary cake accessories are included.</p><label>Cake base<select data-cake-select="base" name="properties[Cake base]"></select></label><label>Cream flavor<select data-cake-select="cream" name="properties[Cream flavor]"></select></label><label>Filling 1<select data-cake-select="filling-1" name="properties[Filling 1]"></select></label><label>Filling 2<select data-cake-select="filling-2" name="properties[Filling 2]"></select></label></div>`;

  const box = document.createElement('section');
  box.className = 'cake-order';
  box.innerHTML = `<style>.cake-order{margin:1.5rem 0;padding:1.25rem;border:1px solid rgba(var(--color-foreground),.2);border-radius:.4rem}.cake-order__fields{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:1rem}.cake-order label,.cake-order__date-label{display:block;margin:.8rem 0 .3rem}.cake-order input,.cake-order select{width:100%;min-height:4rem}.cake-order__option{display:flex!important;align-items:center;gap:.6rem;margin:.7rem 0!important}.cake-order__option input[type=checkbox]{width:auto;min-height:0;margin:0;flex:0 0 auto}.cake-order__status{margin:.8rem 0 0;font-size:1.3rem}.cake-order__status[data-state=error]{color:#b42318}.cake-order__status[data-state=ok]{color:#16794a}.cake-calendar{border:1px solid rgba(var(--color-foreground),.2);border-radius:.4rem;padding:.8rem;margin-top:.4rem}.cake-calendar__head{display:flex;justify-content:space-between;align-items:center;margin-bottom:.6rem}.cake-calendar__head button{min-width:3.2rem;min-height:3.2rem;padding:0}.cake-calendar__week,.cake-calendar__days{display:grid;grid-template-columns:repeat(7,1fr);gap:.25rem;text-align:center}.cake-calendar__week{font-size:1.1rem;color:rgba(var(--color-foreground),.65);margin-bottom:.2rem}.cake-calendar__day{position:relative;min-height:3.3rem;border:0;border-radius:.25rem;background:transparent;padding:0;cursor:pointer}.cake-calendar__day:hover:not(:disabled){background:rgba(var(--color-foreground),.08)}.cake-calendar__day--selected{background:rgb(var(--color-button))!important;color:rgb(var(--color-button-text))}.cake-calendar__day:disabled{color:rgba(var(--color-foreground),.35);cursor:not-allowed}.cake-calendar__day--full{color:rgba(var(--color-foreground),.35);text-decoration:line-through}.cake-calendar__day--full::after{content:'';position:absolute;left:16%;right:16%;top:50%;height:1px;background:currentColor;transform:rotate(-18deg)}.cake-calendar__blank{min-height:3.3rem}@media screen and (max-width:749px){.cake-order__fields{grid-template-columns:1fr}}</style><h3>Pickup details</h3><p>Pickup: Monday to Saturday, 10:00 AM to 8:00 PM. Please order at least 2 days ahead.</p><div class="cake-order__fields"><div><span class="cake-order__date-label">Pickup date</span><input required type="hidden" name="properties[Pickup date]"><div class="cake-calendar" aria-label="Pickup date calendar"><div class="cake-calendar__head"><button type="button" class="cake-calendar__previous" aria-label="Previous month">‹</button><strong class="cake-calendar__month"></strong><button type="button" class="cake-calendar__next" aria-label="Next month">›</button></div><div class="cake-calendar__week"><span>Sun</span><span>Mon</span><span>Tue</span><span>Wed</span><span>Thu</span><span>Fri</span><span>Sat</span></div><div class="cake-calendar__days"></div></div></div><label>Pickup time<select required name="properties[Pickup time]"><option value="">Select a time</option>${['10:00 AM','11:00 AM','12:00 PM','01:00 PM','02:00 PM','03:00 PM','04:00 PM','05:00 PM','06:00 PM','07:00 PM','08:00 PM'].map(t => `<option>${t}</option>`).join('')}</select></label></div>${blindBox ? mysteryChoices : signatureFlavorCake ? plumChoices : cupcakes ? cupcakeChoices : cakePops ? cakePopChoices : ''}${showAccessories ? `<fieldset><legend>Accessories</legend>${accessories.map(([name, price, variant]) => `<label class="cake-order__option"><input class="cake-addon" type="checkbox" data-name="${name}" data-price="${price}" data-variant="${variant}"> ${name} +$${price}</label>`).join('')}</fieldset>` : ''}<p class="cake-order__estimate"${showAccessories || mysteryStyleCake ? '' : ' hidden'}></p><p class="cake-order__status" aria-live="polite"></p>`;

  const addButton = form.querySelector('button[name="add"], [type="submit"]');
  addButton?.addEventListener('click', event => {
    if (form.dataset.cakeSubmitting === 'true') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  }, true);
  (addButton?.parentElement || form).before(box);
  box.after(messageBox);

  const date = box.querySelector('[name="properties[Pickup date]"]');
  const time = box.querySelector('[name="properties[Pickup time]"]');
  const status = box.querySelector('.cake-order__status');
  box.querySelector('.cake-calendar')?.after(status);
  const estimate = box.querySelector('.cake-order__estimate');
  const quantityInput = form.querySelector('[name="quantity"]');
  let dateIsAvailable = false;

  const earliest = new Date();
  earliest.setDate(earliest.getDate() + 2);
  const earliestDate = `${earliest.getFullYear()}-${String(earliest.getMonth() + 1).padStart(2, '0')}-${String(earliest.getDate()).padStart(2, '0')}`;
  date.min = earliestDate;
  const calendar = box.querySelector('.cake-calendar');
  const calendarMonth = calendar?.querySelector('.cake-calendar__month');
  const calendarDays = calendar?.querySelector('.cake-calendar__days');
  let visibleMonth = new Date(earliest.getFullYear(), earliest.getMonth(), 1);
  let calendarRun = 0;
  const isoDate = value => `${value.getFullYear()}-${String(value.getMonth() + 1).padStart(2, '0')}-${String(value.getDate()).padStart(2, '0')}`;
  const isBookableDay = value => isoDate(value) >= earliestDate && value.getDay() !== 0;
  async function getCalendarAvailability(iso, button, run) {
    try {
      const response = await fetch(`https://wei-cake-order-api.szhang0426.workers.dev/availability?date=${encodeURIComponent(iso)}&type=${orderType}&quantity=1`);
      const result = await response.json();
      if (run !== calendarRun || !button.isConnected) return;
      if (!response.ok || !result.available) {
        button.disabled = true;
        button.classList.add('cake-calendar__day--full');
        button.setAttribute('aria-label', `${iso}, fully booked`);
      }
    } catch (_) {
      // A chosen date is checked again before it can be added to cart.
    }
  }
  function renderCalendar() {
    if (!calendar || !calendarDays || !calendarMonth) return;
    const run = ++calendarRun;
    calendarMonth.textContent = visibleMonth.toLocaleDateString(undefined, { month: 'long', year: 'numeric' });
    calendarDays.innerHTML = '';
    const firstDay = new Date(visibleMonth.getFullYear(), visibleMonth.getMonth(), 1);
    const lastDate = new Date(visibleMonth.getFullYear(), visibleMonth.getMonth() + 1, 0).getDate();
    for (let blank = 0; blank < firstDay.getDay(); blank += 1) calendarDays.insertAdjacentHTML('beforeend', '<span class="cake-calendar__blank"></span>');
    for (let day = 1; day <= lastDate; day += 1) {
      const value = new Date(visibleMonth.getFullYear(), visibleMonth.getMonth(), day);
      const iso = isoDate(value);
      const allowed = isBookableDay(value);
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'cake-calendar__day';
      button.textContent = String(day);
      button.dataset.date = iso;
      button.disabled = !allowed;
      if (date.value === iso) button.classList.add('cake-calendar__day--selected');
      button.addEventListener('click', () => {
        date.value = iso;
        date.dispatchEvent(new Event('change', { bubbles: true }));
        renderCalendar();
      });
      calendarDays.append(button);
      if (allowed) getCalendarAvailability(iso, button, run);
    }
  }
  calendar?.querySelector('.cake-calendar__previous')?.addEventListener('click', () => {
    const previous = new Date(visibleMonth.getFullYear(), visibleMonth.getMonth() - 1, 1);
    if (previous >= new Date(earliest.getFullYear(), earliest.getMonth(), 1)) { visibleMonth = previous; renderCalendar(); }
  });
  calendar?.querySelector('.cake-calendar__next')?.addEventListener('click', () => { visibleMonth = new Date(visibleMonth.getFullYear(), visibleMonth.getMonth() + 1, 1); renderCalendar(); });
  renderCalendar();
  const size = () => {
    const selectedSize = form.querySelector('[name="Size"]:checked, select[name="Size"], [name="options[Size]"]:checked, select[name="options[Size]"]')?.value;
    const variantId = String(form.querySelector('[name="id"]')?.value || '');
const variantTitle = window.cakeOrderConfig?.variantSizes?.[variantId] || '';
const variantSize = Number.parseInt(variantTitle, 10);
return Number.parseInt(selectedSize, 10) || variantSize || ((bestHusbandDad || tennisBall) ? 6 : blindSize[variantId] || 4);
  };
  function refreshBlind() {
    if (!mysteryStyleCake) return;
    const s = size();
    const filling2 = box.querySelector('[data-cake-select="filling-2"]');
    if (filling2) {
      const filling2Label = filling2.closest('label');
      if (filling2Label) filling2Label.style.display = blindBox && s === 4 ? 'none' : '';
      filling2.disabled = blindBox && s === 4;
    }
    box.querySelector('[data-cake-select="base"]').innerHTML = options(basePrice[s]);
    box.querySelector('[data-cake-select="cream"]').innerHTML = options(creamPrice[s]);
    box.querySelectorAll('[data-cake-select^="filling-"]').forEach(select => select.innerHTML = options(fillingPricesFor(s, select.dataset.cakeSelect)));
    if (blindBox) box.querySelector('[data-cake-select="finish"]').innerHTML = options(finishPrice[s]);
    updateEstimate();
  }

  function updateEstimate() {
    let total = 0;
    box.querySelectorAll('.cake-addon:checked').forEach(input => total += Number(input.dataset.price));
    if (mysteryStyleCake) {
      const s = size();
      total += basePrice[s][box.querySelector('[data-cake-select="base"]').value] || 0;
      total += creamPrice[s][box.querySelector('[data-cake-select="cream"]').value] || 0;
      box.querySelectorAll('[data-cake-select^="filling-"]:not(:disabled)').forEach(select => {
        total += fillingPricesFor(s, select.dataset.cakeSelect)[select.value] || 0;
      });
      if (blindBox) total += finishPrice[s][box.querySelector('[data-cake-select="finish"]').value] || 0;
    }
    estimate.textContent = total ? `Add-ons: +$${total}` : 'Add-ons: $0';
  }

  refreshBlind();
  updateEstimate();
  form.querySelector('[name="id"]')?.addEventListener('change', refreshBlind);
  box.addEventListener('change', updateEstimate);

  date.addEventListener('change', async () => {
    dateIsAvailable = false;
    status.dataset.state = 'checking';
    if (!date.value || new Date(`${date.value}T12:00:00`).getDay() === 0) {
      status.dataset.state = 'error';
      status.textContent = 'Please choose Monday to Saturday.';
      return;
    }
    status.textContent = 'Checking availability...';
    try {
      const response = await fetch(`https://wei-cake-order-api.szhang0426.workers.dev/availability?date=${encodeURIComponent(date.value)}&type=${orderType}&quantity=1`);
      const result = await response.json();
      if (!response.ok || !result.available) throw new Error(result.error || 'This date is fully booked.');
      dateIsAvailable = true;
      status.dataset.state = 'ok';
      status.textContent = 'Available';
    } catch (error) {
      status.dataset.state = 'error';
      status.textContent = error.message || 'Availability could not be checked.';
    }
  });

  form.addEventListener('submit', async event => {
    if (form.dataset.cakeSubmitting === 'true') return;
    event.preventDefault();
    event.stopImmediatePropagation();

    const quantity = Math.max(1, Number(quantityInput?.value || 1));
    if (cupcakes && !box.querySelector('[name="properties[Cupcake flavor]"]')?.value) {
      status.dataset.state = 'error';
      status.textContent = 'Please select a cupcake flavor.';
      box.querySelector('[name="properties[Cupcake flavor]"]')?.focus();
      return;
    }
    if (cakePops && (!box.querySelector('[name="properties[Cake pop base]"]')?.value || !box.querySelector('[name="properties[Cake pop color]"]')?.value.trim())) {
      status.dataset.state = 'error';
      status.textContent = 'Please select a cake base and enter a color.';
      return;
    }
    const missingRequiredField = [...box.querySelectorAll('[required]')].find(field => !field.value.trim());
    if (missingRequiredField) {
      status.dataset.state = 'error';
      status.textContent = 'Please complete all required selections.';
      missingRequiredField.focus();
      return;
    }
    if (!date.value || !time.value || !dateIsAvailable) {
      status.dataset.state = 'error';
      status.textContent = 'Please select an available pickup date and time.';
      return;
    }

    form.dataset.cakeSubmitting = 'true';
    status.dataset.state = 'checking';
    status.textContent = 'Holding your pickup slot...';
    const reservationId = crypto.randomUUID ? crypto.randomUUID() : String(Date.now());

    try {
      const reserveResponse = await fetch('https://wei-cake-order-api.szhang0426.workers.dev/reserve', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: reservationId, date: date.value, type: orderType, quantity: cakePops ? 1 : quantity })
      });
      const reserveResult = await reserveResponse.json();
      if (!reserveResponse.ok || !reserveResult.ok) throw new Error(reserveResult.error || 'This pickup date is no longer available.');

      const properties = { 'Pickup date': date.value, 'Pickup time': time.value, 'Reservation ID': reservationId };
      if (mysteryStyleCake) {
        ['Cake base', 'Cream flavor', 'Filling 1', ...(blindBox && size() === 4 ? [] : ['Filling 2']), ...(blindBox ? ['Finish'] : [])].forEach(name => {
          properties[name] = box.querySelector(`[name="properties[${name}]"]`).value;
        });
      }
      if (cupcakes) properties['Cupcake flavor'] = box.querySelector('[name="properties[Cupcake flavor]"]').value;
      if (cakePops) {
        properties['Cake pop base'] = box.querySelector('[name="properties[Cake pop base]"]').value;
        properties['Cake pop color'] = box.querySelector('[name="properties[Cake pop color]"]').value;
      }
      const message = form.querySelector('[name="properties[Message]"]');
      if (message?.value.trim()) properties.Message = message.value.trim();

      const items = [{ id: Number(form.querySelector('[name="id"]').value), quantity, properties }];
      const addCharge = (name, price, variantId = addOnVariant[price]) => {
        if (!price) return;
        items.push({ id: variantId, quantity, properties: { 'Cake add-on': `${name} +$${price}`, 'Reservation ID': reservationId } });
      };

      box.querySelectorAll('.cake-addon:checked').forEach(input => {
        addCharge(input.dataset.name, Number(input.dataset.price), Number(input.dataset.variant));
      });
      if (mysteryStyleCake) {
        const s = size();
        const base = box.querySelector('[data-cake-select="base"]').value;
        const cream = box.querySelector('[data-cake-select="cream"]').value;
        const filling1 = box.querySelector('[data-cake-select="filling-1"]').value;
        const filling2 = box.querySelector('[data-cake-select="filling-2"]').value;
        const finish = blindBox ? box.querySelector('[data-cake-select="finish"]').value : null;
        addCharge(`Cake base: ${base}`, basePrice[s][base]);
        addCharge(`Cream flavor: ${cream}`, creamPrice[s][cream]);
        addCharge(`Filling 1: ${filling1}`, fillingPricesFor(s, 'filling-1')[filling1]);
        if (!blindBox || s !== 4) addCharge(`Filling 2: ${filling2}`, fillingPrice[s][filling2]);
        if (blindBox) {
  const finishPriceValue = finishPrice[s][finish] || 0;
  addCharge(`Finish: ${finish}`, finishPriceValue, finishAddOnVariant[finishPriceValue]);
}
      }

      const cartResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!cartResponse.ok) {
        const cartError = await cartResponse.json();
        throw new Error(cartError.description || 'Could not add the cake to cart.');
      }
      location.assign('/cart');
    } catch (error) {
      form.dataset.cakeSubmitting = '';
      status.dataset.state = 'error';
      status.textContent = error.message || 'Could not add the cake to cart.';
    }
  }, true);
})();
